// Shared metadata for Best Practices: categories + levels
import {
  Stethoscope, Heart, Wheat, Baby, Syringe, Bug, Home,
  Smile, Users, Apple, AlertCircle, BookOpen,
} from "lucide-react";

export const BP_CATEGORIES = [
  { id: "sante",             label: "Santé",             icon: Stethoscope, color: "#C84B31" },
  { id: "reproduction",      label: "Reproduction",      icon: Heart,       color: "#E05A3D" },
  { id: "alimentation",      label: "Alimentation",      icon: Wheat,       color: "#7A5A1C" },
  { id: "agnelage",          label: "Agnelage",          icon: Baby,        color: "#D97706" },
  { id: "vaccination",       label: "Vaccination",       icon: Syringe,     color: "#1E6BBA" },
  { id: "parasites",         label: "Parasites",         icon: Bug,         color: "#1C7A3C" },
  { id: "bergerie",          label: "Bergerie",          icon: Home,        color: "#1C3A27" },
  { id: "bien_etre",         label: "Bien-être animal",  icon: Smile,       color: "#E05A3D" },
  { id: "gestion_troupeau",  label: "Gestion du troupeau", icon: Users,     color: "#5C6B5C" },
  { id: "nutrition",         label: "Nutrition",         icon: Apple,       color: "#C84B31" },
  { id: "premiers_secours",  label: "Premiers secours",  icon: AlertCircle, color: "#D32F2F" },
];

export const BP_LEVELS = [
  { id: "debutant",      label: "Débutant",      color: "#1C7A3C" },
  { id: "intermediaire", label: "Intermédiaire", color: "#D97706" },
  { id: "expert",        label: "Expert",        color: "#C84B31" },
];

export const DEFAULT_BP_ICON = BookOpen;

export const getCategoryMeta = (id) =>
  BP_CATEGORIES.find((c) => c.id === id) || {
    id, label: id, icon: DEFAULT_BP_ICON, color: "#5C6B5C",
  };

export const getLevelMeta = (id) =>
  BP_LEVELS.find((l) => l.id === id) || { id, label: id, color: "#5C6B5C" };
